module.exports = __webpack_public_path__ + "static/media/logo_evolua.9e20dbb8.svg";